import React, { useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import html2pdf from "html2pdf.js";
// import {formatProjectDate} from "../../../controllers/common";
const Invoice = () => {
    const printRef = useRef();
    const location = useLocation();
    const voucherData = location?.state;
    

    const generatePdf = async () => {
        try {
                const element = printRef.current;
                const options = {
                    margin      : .25,
                    filename    : `Winning Voucher ${voucherData?.voucher_no} - ${moment(new Date()).format('DD-MM-YYYY')}.pdf`,
                    image       : { type: "jpeg", quality: 1 },
                    html2canvas : { dpi: 1200, letterRendering: true, scale: 3 },
                    jsPDF       : { unit: "in", format: [8.5, 11], orientation: "portrait" }
                };
                await html2pdf().from(element).set(options).save();
        } finally {
            // if(autoClose === 'Y'){
            //     window.close();
            // }
        }
      };

      useEffect(()=>{
        generatePdf();
      },[]);
  return (
  <>
    <div className="invoice-container" id="invoice" ref={printRef} style={{
        maxWidth: '800px',
        margin: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        fontSize: '13px',
      }}>
        <div className="logo-image" style={{display: 'flex',justifyContent: 'center'}}>
            <img
            src='/static/media/SideBarIcon.2269b347427947c916aa.png'
            alt="Logo"
            style={{width: "20%"}}
            />            
        </div>
        <h4 className="invoice-title" style={{textAlign: 'center',marginBottom: '10px', fontSize : "32px"}}>WINNING GIFT VOUCHER</h4>
        <hr/>
        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '10px'}}>
            <tbody>
                <tr>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Payment To</b></th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Voucher No.</b></th>
                    <th colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Date</b></th>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.payment_to}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.voucher_no}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{moment(voucherData?.date).format("DD-MM-YYYY")}</td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Seller name</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>CPR/Passport No.</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Purchase Date</b></td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.seller_name}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.document_no}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{moment(voucherData?.purchase_date).format("DD-MM-YYYY")}</td>
                </tr>
                
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Ticket ID</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Product Name</b></td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}><b>Contact No.</b></td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.order_no}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.game_name}</td>
                    <td colSpan="2" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}>{voucherData?.contact_no}</td>
                </tr>

            </tbody>
        </table>

        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '10px'}}>
            <tbody>
                <tr>
                    <th colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',textAlign: 'left',color : '#000000ff'}}>
                        <b>Description</b>
                    </th>
                    <th colSpan="1" className="text-center" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',color : '#000000ff'}}>
                        <b>No. of winning</b>
                    </th>
                    <th colSpan="1" className="text-right" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963', textAlign : 'right',color : '#000000ff'}}>
                        <b>Amount</b>
                    </th>
                </tr>
                {(voucherData?.winnerList && voucherData?.winnerList?.length > 0) && voucherData?.winnerList.map((item, index)=>(
                    <tr key={index}>
                        <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}> Winning Amount-{item?.amount} </td>
                        <td colSpan="1" className="text-center" style={{border: '1px solid #ddd',padding: '8px'}}> {item?.qty} </td>
                        <td colSpan="1" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> KD {item?.total} </td>
                    </tr>
                ))}

                {/* <tr>
                    <td colSpan="4" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left'}}> Winning Amount-10 </td>
                    <td colSpan="1" className="text-center" style={{border: '1px solid #ddd',padding: '8px'}}> 3 </td>
                    <td colSpan="1" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right'}}> KD 30.00 </td>
                </tr> */}
                
                
                <tr style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#f2f2f2'}} >
                    <td colSpan="5" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'left',backgroundColor: '#136bb963',color : '#000000ff'}}><b>Net amount</b></td>
                    <td colSpan="1" className="text-left" style={{border: '1px solid #ddd',padding: '8px',textAlign: 'right',backgroundColor: '#136bb963',color : '#000000ff'}}><b>KD {voucherData?.total_amount}</b></td>
                </tr>
                
            </tbody>
        </table>
        <hr/>
        <table className="invoice-table" style={{width: '100%',borderCollapse: 'collapse',marginBottom: '5px'}}>
            <tbody>
                <tr>
                    <th colSpan="8" className="text-center" style={{border: '1px solid #ddd',padding: '8px',backgroundColor: '#136bb963',color : '#000000ff',textAlign: 'left',}}><b>No Objection Letter</b></th>
                </tr>
                <tr>
                    <th colSpan="8" className="text-center" style={{border: '1px solid #ffffffff',padding: '20px', backgroundColor: '#ffffffff',whiteSpace: 'normal', wordWrap : "break-word"}}>
                        I <b>{voucherData?.payment_to}</b> holding {voucherData?.document_type} : <b>{voucherData?.document_no}</b> do hereby declare and confirm that I have received the above draw amount as cash from Every Day Discount Center.
                    </th>
                </tr>
                <tr>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left',backgroundColor: '#136bb963',color : '#000000ff'}}>
                    <b> Received By </b>
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left',backgroundColor: '#136bb963',color : '#000000ff'}}>
                    <b>Prepared By</b>
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left',backgroundColor: '#136bb963',color : '#000000ff'}}>
                    <b>Checked By</b> 
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left',backgroundColor: '#136bb963',color : '#000000ff'}}>
                    <b>Authorized By</b>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left'}}>
                    {voucherData?.received_by}
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left'}}>
                    {voucherData?.prepared_by}
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left'}}>
                    {voucherData?.checked_by}
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',padding: '10px',textAlign: 'left'}}>
                    {voucherData?.authorized_by}
                    </td>
                </tr>

                <tr>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',textAlign: 'left', height: '70px'}}>
                    
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',textAlign: 'left', height: '70px'}}>
                    
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',textAlign: 'left', height: '70px'}}>
                    
                    </td>
                    <td colSpan="2" className="text-center" style={{border: '1px solid #ddd',textAlign: 'left', height: '70px'}}>
                    
                    </td>
                </tr>
            </tbody>
        </table>

        {/* Additional tables with similar structure */}
        <div className="footer" style={{ marginTop: '10px',textAlign: 'center' }}>
            {/* <b>U WINN L.L.C-FZ</b> */}
            <p>-- Thank You -- </p>
        </div>
    </div>
  </>);
};

export default Invoice;
